export default {
    "fr": {
        "Blog": "blog",
        "Published on {date}": "Publié le {date}",
        "This might interest you": "Cela pourrait vous intéresser",
        "Here’s a selection of related posts": "Voici une sélection d'articles que nous vous propopons",
        "View all": "Voir toutes les actualités",
        "Our latest news": "Nos dernières actualités"
    },
    "en": {
        "Blog": "blog",
        "Published on {date}": "Published on {date}",
        "This might interest you": "This might interest you",
        "Here’s a selection of related posts": "Here’s a selection of related posts",
        "View all": "View all",
        "Our latest news": "Our latest news"
    }
}
